import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as featureActions from '../../index';
import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { ActivateLicenseActionTypes, ActivateLicenseActions } from '../actions/activate-license.actions';
import {LicenseMgtService} from '../../../services/license-mgt.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {licenseMap, updateInfoType} from '../../../shareModel';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class ActivateLicenseEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private licenseMgtService = inject(LicenseMgtService);
  private injector = inject(Injector);


  constructor() {}

  GetActivateLicenses$ = createEffect(() => this.actions$.pipe(
    ofType(ActivateLicenseActionTypes.GetActivateLicenses),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...action.payload, otp: user.otp };
      return this.licenseMgtService.ActivateLicense(payload).pipe(
        map((res: any) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.ActivateLicense
          };
          if (res.result && !res.errmsg) {
            const data = res.msg.body;
            if (data.msgType === 0) {
              return new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') });
            }
            const errorIndex = data.msgType === 1 ? 0 :
              data.msgType === 2 ? 2 :
              data.msgType === 3 || (data.msgType === 4 && data.LicenseType === 2) ? 3 : null;
            const errmsg = errorIndex === null
              ? updateRes.errmsg
              : this.injector.get(TranslateService).instant(licenseMap.CheckErrorMsg[errorIndex], {Default: licenseMap.CheckErrorMsg[errorIndex]});
            return new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg });
          } else {
            return new featureActions.UpdateInfoFailAction(res);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const updateRes: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.ActivateLicense
          };
          return of(new featureActions.UpdateInfoFailAction(updateRes));
        })
      );
    })
  ));



}
